export enum SearchMessageType {
  Draft = 'Draft',
  Favorite = 'Favorite',
  FeedItem = 'FeedItem',
  MessageAppearance = 'MessageAppearance',
  MessageSetMessage = 'MessageSetMessage',
  Pick = 'Pick'
}
